import React, { useEffect, useState } from 'react';
import { galleryAPI, ServiceSubType } from '../../services/galleryApi';
import toast from 'react-hot-toast';

interface SubTypeSelectorProps {
  serviceTypeId: string | null; // The ID of the selected ServiceType
  selectedSubTypeId: string | null;
  onSelectSubType: (subTypeId: string) => void;
  allowEmpty?: boolean; // Option to allow an empty/default selection
}

const SubTypeSelector: React.FC<SubTypeSelectorProps> = ({ serviceTypeId, selectedSubTypeId, onSelectSubType, allowEmpty = false }) => {
  const [serviceSubTypes, setServiceSubTypes] = useState<ServiceSubType[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!serviceTypeId) {
      setServiceSubTypes([]);
      return;
    }

    const fetchServiceSubTypes = async () => {
      try {
        setLoading(true);
        setError(null);
        const subTypes = await galleryAPI.getServiceSubTypes(serviceTypeId);
        setServiceSubTypes(subTypes);
      } catch (err) {
        console.error('Failed to fetch service sub-types:', err);
        setError('Failed to load service sub-types.');
        toast.error('Erreur lors du chargement des sous-types de service.');
      } finally {
        setLoading(false);
      }
    };

    fetchServiceSubTypes();
  }, [serviceTypeId]);

  if (!serviceTypeId) {
    return <select className="select select-bordered w-full" disabled><option>Sélectionnez d'abord un type</option></select>;
  }

  if (loading) {
    return <select className="select select-bordered w-full" disabled><option>Chargement des sous-types...</option></select>;
  }

  if (error) {
    return <div className="text-error">{error}</div>;
  }

  return (
    <select
      className="select select-bordered w-full"
      value={selectedSubTypeId || ''}
      onChange={(e) => onSelectSubType(e.target.value)}
    >
      {allowEmpty && <option value="">Sélectionner un sous-type (optionnel)</option>}
      {serviceSubTypes.map((subType) => (
        <option key={subType._id} value={subType._id}>
          {subType.name}
        </option>
      ))}
    </select>
  );
};

export default SubTypeSelector;
